import { Component, ElementRef, ViewChild } from '@angular/core';
import { SearchService, SearchTermChangedEvent } from "../../services/search.service";
import { EventService } from "../../services/event.service";


@Component({
  selector: 'search-field',
  templateUrl: 'search-field.html'
})
export class SearchField {

  _searchTerm: string = null;
  
  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(public searchService: SearchService,
              private eventService: EventService
  ) {
    
    
    eventService.searchTermChanged.subscribe((searchTermData: SearchTermChangedEvent) => {
      if(searchTermData.origin !== 'doSearchEvent') {
        this._searchTerm = searchTermData.searchTerm;
      }
    })
    
	}
	
	ngOnInit(){
    //Fill search term if direct search from URL
    this._searchTerm = this.searchService.searchTerm;
  }

	
	doSearch(event): void {
    this.eventService.doSearch.emit(this._searchTerm);
    if(this.searchInput) {
      this.searchInput.nativeElement.blur();
    }
    this.eventService.toggleKeyboard.emit(false);
  }

}



// WEBPACK FOOTER //
// ./src/partials/search-field/search-field.ts